<template>
  <div>
    <div class="note" @click="showHint(true)"></div>
    <div class="note-bubble" :class="{ active }" @click="showHint(false)">
      <p>{{content}}</p>
      <div class="note-bubble__close"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Note',
  props: {
    content: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      active: false
    }
  },
  methods: {
    showHint (val) {
      this.active = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assetComponents/Note.vue